import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { addPrayer, deletePrayer, fetchPrayerList, updatePrayer } from "src/services/prayer.service";
import { getAuthToken } from "../config";

// fetch prayer list
export const doFetchPrayerList = createAsyncThunk(
  "prayer/fetchPrayerList",
  async (payload: { search?: string; page: number; limit: number }) => {
    try {
      const response: any = await fetchPrayerList({
        search: payload.search,
        page: payload.page,
        limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to fetch prayer list";
      console.log(errorMessage);
      throw errorMessage;
    }
  }
);

// add prayer
export const doAddPrayer= createAsyncThunk(
  "prayer/addPrayer",
  async ( body : { 
      title: string; 
      description: string; 
      iconImage: string; 
      pcids?: string; // Make optional
      audioUrl: string; 
      audioDuration: string 
    }, { getState, rejectWithValue }) => {
    const accessToken = getAuthToken();
    if (!accessToken) {
      throw new Error("Authentication token not found");
    }
    try {
      if(body.pcids===""){
        delete body.pcids;
      }
      const response: any = await addPrayer(body);
      return response;
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to add prayer");
      return rejectWithValue(
        error.response?.data?.message || "Failed to add prayer"
      );
    }
  }
);

// update prayer
export const doUpdatePrayer = createAsyncThunk(
  "prayer/updatePrayer",
  async (
    { id, body }: { id: string; body: { title: string; description: string; iconImage: string; pcids?: string; audioUrl: string; audioDuration: string } },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await updatePrayer(id, body);
      toast.success("Prayer updated successfully!");
      return { id, data: response.data };
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to update prayer";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

// delete prayer
export const doDelPrayer = createAsyncThunk(
  "prayer/delPrayer",
  async (id: string) => {
    try {
      const response: any = await deletePrayer(id);
      toast.success(response.message);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete prayer";
      toast.error(errorMessage);
      throw errorMessage;
    }
  }
);
